import axios from "axios";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const ACTION_TYPES = {
  FETCH_COMMENTS: "brokerComments/FETCH_COMMENTS",
  FETCH_COMMENT_DETAILS: "brokerComments/FETCH_COMMENT_DETAILS",
  FETCH_COMMENT_OPTIONS: "brokerComments/FETCH_COMMENT_OPTIONS",
  CREATE_COMMENT: "brokerComments/CREATE_COMMENT",
  DOWNLOAD_COMMENT: "brokerComments/DOWNLOAD_COMMENT",
};

const initialState = {
  loading: false,
  commentsList: [],
  commentDetails: null,
};

export type BrokerCommentsState = Readonly<typeof initialState>;

/**
 * Broker Comments Reducer
 */
export default (state: BrokerCommentsState = initialState, action): BrokerCommentsState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.FETCH_COMMENTS):
    case PENDING(ACTION_TYPES.FETCH_COMMENT_DETAILS):
    case PENDING(ACTION_TYPES.FETCH_COMMENT_OPTIONS):
      return { ...state, loading: true };

    case FULFILLED(ACTION_TYPES.FETCH_COMMENTS): {
      return {
        ...state,
        loading: false,
        commentsList: action.payload.data,
      };
    }

    case FULFILLED(ACTION_TYPES.FETCH_COMMENT_DETAILS):
      return { ...state, loading: false, commentDetails: action.payload.data };

    case FULFILLED(ACTION_TYPES.FETCH_COMMENT_OPTIONS):
      return { ...state, loading: false, commentDetails: action.payload.data };

    case REJECTED(ACTION_TYPES.FETCH_COMMENT_DETAILS):
    case REJECTED(ACTION_TYPES.FETCH_COMMENTS):
    case REJECTED(ACTION_TYPES.FETCH_COMMENT_OPTIONS):
      return { ...state, loading: false };

    default:
      return state;
  }
};

/**
 * Actions for fetching broker comments data
 */
export const fetchBrokerCommentsList = ({ brokerID, page, rows, sort, query }) => ({
  type: ACTION_TYPES.FETCH_COMMENTS,
  meta: { listOptions: { page, rows, sort, query } },
  payload: axios.get(`applications/comments`, {
    params: { moduleId: 2, keyId: brokerID, rows, page, sort, ...query },
  }),
});

export const fetchBrokerCommentDetails = (commentId: number) => ({
  type: ACTION_TYPES.FETCH_COMMENT_DETAILS,
  payload: axios.get(`applications/comments/${commentId}?moduleId=2`),
});

export const fetchBrokerCommentOptions = () => ({
  type: ACTION_TYPES.FETCH_COMMENT_OPTIONS,
  payload: axios.get("applications/comments/new?moduleId=2"),
});

export const submitBrokerComment = (brokerID, userID, payload) => ({
  type: ACTION_TYPES.FETCH_COMMENTS,
  payload: axios.post(`applications/comments?moduleId=2`, { contactId: brokerID, createdBy: userID, ...payload }),
});
